import { css } from 'styled-components';
import { lg, xl } from '@exonet/react-shared/lib/styled';

export default css`
  * {
    box-sizing: border-box;
  }

  body,
  html {
    color: var(--text);
    background-color: var(--body-bg);
  }

  #app {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    min-height: 100vh;
    max-width: 100vw;
  }

  ul {
    &:not(.list) {
      margin: 0;
      padding: 0;

      > li {
        list-style-type: none;
      }
    }

    &.list {
      > li {
        font-size: var(--font-size);
        margin-bottom: 0.6em;
      }
    }
  }

  form {
    background-color: var(--form-bg);
    border-radius: var(--border-radius);
    box-shadow: none;
    padding: var(--xs-padding);
    margin-bottom: var(--xs-padding-vertical);

    ${lg(css`
      padding: var(--lg-padding);
      margin-bottom: var(--lg-padding-vertical);
    `)}

    ${xl(css`
      padding: var(--xl-padding);
      margin-bottom: var(--xl-padding-vertical);
    `)}
  }

  .shared-modal {
    form {
      padding: 0;
    }
  }

  .shared-page-header > .title {
    display: flex;
    align-items: center;
  }

  /* Pin the header height inside data-managers and their skeletons, so pages
     with and without header action buttons (and the loading state) all render
     the title row at the same height — no shift on load. */
  .data-manager .shared-page-header,
  .data-manager-skeleton .shared-page-header {
    min-height: var(--data-manager-header-min-height);
  }

  .data-manager,
  .shared-label-list,
  .data-manager-skeleton {
    .data-manager-controls {
      min-height: var(--data-manager-controls-min-height);
    }

    .data-manager-content {
      min-height: 200px;

      padding: var(--xs-padding);
      background-color: var(--form-bg);
      border-radius: var(--border-radius);
      box-shadow: var(--form-box-shadow, var(--box-shadow));
      color: var(--text);

      ${lg(css`
        padding: var(--lg-padding);
      `)};

      ${xl(css`
        padding: var(--lg-padding);
      `)};

      .shared-table {
        box-shadow: none;

        .column {
          font-variant-numeric: tabular-nums;
        }
      }
    }
  }

  /* Loading placeholders: theme the colors (the WebAwesome defaults look
     blueish, especially in dark mode) and tone down the default pill rounding.
     The negative delay starts the 8s sheen cycle right where the glint sweeps
     into view, so it shows immediately on mount instead of ~2.5s in. */
  wa-skeleton {
    --color: var(--skeleton-color);
    --sheen-color: var(--skeleton-sheen-color);
  }

  wa-skeleton::part(indicator) {
    border-radius: var(--border-radius);
    animation-delay: -2.5s;
  }

  .shared-table {
    .header {
      border-bottom: 1px solid var(--table-header-border) !important;
    }

    .table-header:after {
      background-color: var(--table-header-seperator) !important;
    }

    .item {
      :not(:last-child) {
        border-bottom: 1px solid var(--table-row-border);
      }

      .column:after {
        display: none;
      }
    }

    .column {
      font-variant-numeric: tabular-nums;
    }
  }

  > .react-tooltip {
    z-index: 99999;
  }

  /* A tooltip is a label, not a line of text without end: a service name of a hundred characters
     otherwise stretches the bubble past both edges of the screen. */
  .react-tooltip {
    max-width: min(28rem, 90vw);
    overflow-wrap: anywhere;
  }
`;
